import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "./Navbar";
import Section1 from "./LandingPageComponents/Section1";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const userStore = useSelector((store) => store.UserReducer);
  const navigate = useNavigate();

  useEffect(() => {
    if (userStore.isAuth) {
      if (userStore?.role === 'super_admin' || userStore?.role === 'admin') {
        navigate("/admin/dashboard");
      } else if (userStore?.role === 'teacher' || userStore?.role === 'instructor') {
        navigate("/teacher-dashboard");
      } else {
        navigate("/home");
      }
    }
  }, [userStore.isAuth, navigate, userStore?.role]);

  return (
    <Box overflow="hidden" h="100dvh" maxH="100dvh">
      <Navbar />
      <Section1 />
    </Box>
  );
};

export default LandingPage;
